import type { RuntimeState as BuilderRuntimeState } from '@/workflow-builder/_contract/runtime';
import type { RuntimeState } from '@/workflow-runner/_contract/runtime';
import type { InteractiveRuntimeState } from '@/workflow/modes/_@shared/_contract/mode';

export function requireRunnerRuntimeState(
    runtimeState: InteractiveRuntimeState,
): RuntimeState {
    if (runtimeState.adapterMode !== 'runner') {
        throw new Error('Runner workflow augmentation requires runner runtime state.');
    }
    return runtimeState;
}

export function requireBuilderRuntimeState(
    runtimeState: InteractiveRuntimeState,
): BuilderRuntimeState {
    if (runtimeState.adapterMode !== 'builder') {
        throw new Error('Builder workflow augmentation requires builder runtime state.');
    }
    return runtimeState;
}
